import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#2F5D6C',
    main: '#3E7A8A',
    light: '#A6CBD5'
  },
  secondary: {
    contrastText: white,
    dark: '#90AFC5',
    main: '#B7D1E2',
    light: '#E3EFF7'
  },
  success: {
    contrastText: white,
    dark: '#388E3C',
    main: '#51c957',
    light: '#A5D6A7'
  },
  info: {
    contrastText: white,
    dark: '#1E3A5F',
    main: '#3b75d1',
    light: '#90CAF9'
  },
  warning: {
    contrastText: white,
    dark: '#F57C00',
    main: '#FFB74D',
    light: '#FFE0B2'
  },
  error: {
    contrastText: white,
    dark: '#C62828',
    main: '#E57373',
    light: '#FFCDD2'
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  background: {
    default: '#F4F6F8',
    paper: white
  },
  palette01: {
    contrastText: white,
    dark: colors.indigo[800],
    main: colors.indigo[600],
    light: colors.indigo[50]
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};
